
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnChanges,
  OnInit,
  SimpleChanges,
  DOCUMENT
} from '@angular/core';
import { BloomreachComponent } from '@app/shared/base-classes/bloomreach-component';
import { StorageService } from '@core/services';
import { BehaviorSubject } from 'rxjs';
import { GlobalUtilityHeaderMapper } from './global-utility-header.mapper';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BreakpointValues } from '@app/shared/constants';

@Component({
    selector: 'mflooring-global-utility-header',
    templateUrl: './global-utility-header.component.html',
    styleUrls: [
        './global-utility-header.shared.scss',
        './global-utility-header.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GlobalUtilityHeaderComponent
	extends BloomreachComponent
	implements OnInit, OnChanges
{
	public openedMenu: number;

	// public utilityHeaderData$ = new BehaviorSubject<any>(null);

	public layoutContainerProp = {
		content: {
			backgroundColor: '#CCCDCE',
		},
		presentation: {
			isInset: false,
		},
	};

	public isMobile: boolean;

	constructor(
		private eRef: ElementRef,
		public storage: StorageService,
		@Inject(DOCUMENT) private documentRef: Document,
		private breakpoint: BreakpointObserver
	) {
		super(storage);
	}

	openMenu(index: number): void {
		if (this.openedMenu === index) {
			this.closeMenu();
			return;
		}
		this.openedMenu = index;
	}

	get menuFlatted() {
		return this.flatMenu(this.menu.siteMenuItems);
	}

	get pageTitleVisDemo() {
		return this.documentRef.title?.split(' ')?.[0];
	}

	private flatMenu(siteMenuItems: any) {
		return siteMenuItems.reduce(
			(acc, curr) =>
				curr.childMenuItems.length
					? [...acc, curr, ...this.flatMenu(curr.childMenuItems)]
					: [...acc, curr],
			[]
		);
	}

	closeMenu() {
		this.openMenu(null);
	}

	// TODO: Once the action icons work it should be moved to a menu container as wrapper.
	@HostListener('document:click', ['$event'])
	closeMenuOutside(event) {
		try {
			if (!this.eRef.nativeElement.contains(event.target)) {
				this.closeMenu();
			}
		} catch (error) {}
	}

	ngOnInit() {
		// this.utilityHeaderData$.next(
		// 	GlobalUtilityHeaderMapper(this.resourceBundleData)
		// );
	}

	ngOnChanges(changes: SimpleChanges) {
		this.isMobile = this.breakpoint.isMatched(BreakpointValues.mobileMax);
	}
	@HostListener('window:resize') onResize() {
		this.isMobile = this.breakpoint.isMatched(BreakpointValues.mobileMax);
	}
}
